import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {mergeMap as _observableMergeMap, catchError as _observableCatch, } from "rxjs/operators";
import {Observable,throwError as _observableThrow,of as _observableOf,of, observable} from "rxjs"; 
import { ApiException } from "../services/api.service";
import { HttpClient } from "@angular/common/http";
export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");  
@Injectable({
    providedIn: "root",
  })
export class BaseClient
{
    protected http: HttpClient;
    public baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    
    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string){
        this.http = http;
        this.baseUrl =
          baseUrl !== undefined && baseUrl !== null
            ? baseUrl
            : "https://findmirest.azurewebsites.net";
           
    }
    blobToText(blob: any): Observable<string> {
        return new Observable<string>((observer: any) => {
          if (!blob) {
            observer.next("");
            observer.complete();
          } else {
            let reader = new FileReader();
            reader.onload = (event) => {
              observer.next((event.target as any).result);
              observer.complete();
            };
            reader.readAsText(blob);
          }
        });
      }
      throwException(
        message: string,
        status: number,
        response: string,
        headers: { [key: string]: any },
        result?: any
      ): Observable<any> {
       
        if (result !== null && result !== undefined) return _observableThrow(result);
        else
      
          return _observableThrow(
            new ApiException(message, status, response, headers, null)
          );
      }
}